import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdoptionTrackingService {
  private sent = new Set<string>();

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  start(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.trackRoute(event.urlAfterRedirects || event.url);
    });
  }

  track(eventName: string, metadata: Record<string, string | number> = {}): void {
    const user = this.authService.getLoggedInUser();
    if (!user) {
      return;
    }
    const key = eventName + ':' + JSON.stringify(metadata);
    if (this.sent.has(key)) {
      return;
    }
    this.sent.add(key);
    this.http.post(`${environment.apiURI}/adoption/events`, { event_name: eventName, metadata }).subscribe({
      error: () => undefined,
    });
  }

  private trackRoute(url: string): void {
    const user = this.authService.getLoggedInUser();
    if (!user) {
      return;
    }
    const path = url.split('?')[0];
    const isParent = !!user.is_student;
    const isTeacher = !!user.is_teacher;

    const events: string[] = [];
    if (path === '/home' && isParent) {
      events.push('parent.app_opened', 'parent.student_dashboard_viewed');
    } else if (path === '/staff-home' && isTeacher) {
      events.push('teacher.app_opened');
    } else if (path.startsWith('/attendance')) {
      events.push(isParent ? 'parent.attendance_viewed' : 'teacher.attendance_viewed');
    } else if (path.startsWith('/take-attendance') || path.startsWith('/staff-attendance')) {
      events.push('teacher.attendance_viewed');
    } else if (path.startsWith('/fees') || path.startsWith('/pay-online') || path.startsWith('/show-payment-history')) {
      events.push('parent.fee_details_viewed');
    } else if (path.startsWith('/result') || path.startsWith('/report-card') || path.startsWith('/gradebook')) {
      events.push(isParent ? 'parent.gradebook_viewed' : 'teacher.gradebook_viewed');
    } else if (path.startsWith('/notices') || path.startsWith('/events')) {
      events.push(isParent ? 'parent.notice_viewed' : 'teacher.notice_viewed');
    } else if (path.startsWith('/student-class-work') || path.startsWith('/student-assignments')) {
      events.push('parent.homework_viewed');
    } else if (path.startsWith('/timetable')) {
      events.push('teacher.timetable_viewed');
    }

    events.forEach((name) => this.track(name, { screen: path }));
  }
}
